import { makeStyles } from '@material-ui/core/styles';

const FiltersDetailsUseStyles = makeStyles(theme => ({
  FiltersDetails: {
    '&__table': {
      position: 'relative',
      backgroundColor: theme.palette.blackAlfa,
      display: 'flex',
      justifyContent: 'space-between',
      borderRadius: 5,
      padding: 15,
      opacity: 1,
      zIndex: 10,
      transition: 'opacity 0.5s',

      '&__filters': {
        '&__add': {
          height: '100%',
          padding: 0,
          margin: 0,
          marginBottom: 5,
          '&__form': {
            width: '100%',
            height: '100%',
            '&__label': {
              fontSize: '12px',
              fontWeight: 500,
              color: theme.palette.white,
              transform: 'translate(0px,0px)',
              '&--focused': {
                fontWeight: 600,
                color: `${theme.palette.green} !important`,
              },
            },
            '&__select': {
              height: 25,
              marginTop: '0px !important',
            },
            '&__underline': {
              '&:after': {
                borderBottomColor: `${theme.palette.green} !important`,
              },
            },
            '&--color': {
              color: theme.palette.white,
            },
          },
          '&__details': {
            '&__button': {
              '&__close': {
                border: `2px solid ${theme.palette.white}`,
                backgroundColor: theme.palette.green,
                borderRadius: '50%',
                cursor: 'pointer',
                position: 'absolute',
                right: 5,
                top: 25,
                zIndex: 1003,
              },
            },
          },
        },
        '&__search': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          '&__button': {
            width: 25,
            height: 25,
            borderRadius: '50%',
            border: `2px solid ${theme.palette.white}`,
            backgroundColor: theme.palette.green,
            color: theme.palette.black,
            padding: 0,
            margin: 0,
            minWidth: 'initial',
            transition:
              'color .25s, background-color 0.25s, border-color 0.25s',
            '& svg': {
              width: 15,
              height: 15,
            },
            '&:hover': {
              color: theme.palette.white,
              backgroundColor: theme.palette.green,
              borderColor: theme.palette.green,
            },
          },
        },
      },
      '&__details': {
        color: theme.palette.white,
        fontWeight: 500,
        padding: 10,
        width: '100%',
        '&__scroll': {
          padding: '5px 0',
          height: '100%',
          maxHeight: 250,
          margin: '5px 0',
          overflowY: 'auto',
        },
        '&__container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          '&__button': {
            borderRadius: theme.palette.dashboard.filters.buttonBorder,
            boxShadow: `${theme.palette.dashboard.filters.buttonBoxShadow} !important`,
            backgroundColor:
              theme.palette.dashboard.filters.buttonBackgroundColor,
            color: theme.palette.dashboard.filters.buttonColor,
            margin: 5,
            width: 150,
            height: 50,
            '&--big': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            },
          },
        },
      },
      '&__calendar': {
        minHeight: 85,
        '&__search': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'column',
        },
        '&--flex': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      '&--padding': {
        padding: 5,
      },
    },
  },
  Filters: {
    height: 'auto',
    width: '100%',
    '&__autocomplete': {
      marginBottom: 25,
      '&__button': {
        right: 25,
      },
    },
    '&__button': {
      textAlign: 'right',
    },
    '&__filter-wrapper': {
      position: 'relative',
    },
    '&__icon-close': {},
    '&__icon-close-time': {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      height: '100%',
      position: 'absolute',
      right: 5,
      zIndex: 1003,
    },
    '&__select': {
      minWidth: 120,
    },
    '&--flex': {
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
    },
  },
}));

export { FiltersDetailsUseStyles };
